<template>
    <div>
        <v-container fluid class="pt-0 pb-0 mb-5">
            <v-form
                    ref="queryForm">
                <v-row align="center" justify="center" class="pl-6" style="background-color:#fff;">
                    <v-col
                            :sm="3"
                            :md="2"
                            :lg="2"
                            cols="2">
                        <Z-Source-Selector label="机构"
                                           source="HospSelector"
                                           v-model="query.hospId"></Z-Source-Selector>
                    </v-col>
                    <v-col
                            :sm="3"
                            :md="2"
                            :lg="2"
                            cols="2">
                        <Z-Source-Selector label="部门"
                                           source="DeptSelector"
                                           :param="query.hospId"
                                           v-model="query.deptId"></Z-Source-Selector>
                    </v-col>
                    <v-col
                            :sm="3"
                            :md="1"
                            :lg="1"
                            cols="1">
                        <Z-Source-Selector label="采集器状态"
                                           source="DicSelector"
                                           param="COLLECTOR_STATE"
                                           v-model="query.collectorState"></Z-Source-Selector>
                    </v-col>
                    <v-col
                            :sm="3"
                            :md="1"
                            :lg="1"
                            cols="1" class="d-flex justify-center">
                        <v-switch v-model="query.isWarning" class="ma-2" label="预警状态"></v-switch>
                    </v-col>

                    <v-col
                            :sm="3"
                            :md="1"
                            :lg="1"
                            cols="1" class="d-flex justify-center">
                        <v-switch v-model="query.isBinding" class="ma-2" label="是否安装"></v-switch>
                    </v-col>

                    <v-col
                            :sm="3"
                            :md="3"
                            :lg="3"
                            cols="3">
                        <v-text-field
                                label="采集器MAC/采集器名称/采集器编号/监控对象编号"
                                prepend-inner-icon="search"
                                clearable
                                v-model="query.queryCondition"
                        ></v-text-field>
                    </v-col>
                    <v-col
                            :sm="6"
                            :md="2"
                            :lg="2"
                            class="pt-0"
                            cols="2">
                        <v-btn color="primary"
                               small
                               :loading="loading.queryRequest"
                               @click="search">
                            搜索
                        </v-btn>
                        <v-btn
                                color="primary"
                                small
                                class="ma-2"
                                @click="resetQuery">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                        <v-btn color="primary"
                               small
                               @click="handleBatchImport">
                            批量导入
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" class="pl-2" style="background-color:#fff;">
                    <v-col >
                        <v-btn
                                color="primary"
                                middle
                                class="ma-2"
                                @click="jump('http://www.1064.cn/manage.html')">
                            物联网卡管理
                        </v-btn>
                        <v-btn
                                color="primary"
                                middle
                                class="ma-2"
                                @click="jump('http://bridge.iotworkshop.com/dashboard.html')">
                            数据终端
                        </v-btn>
                        <v-btn
                            color="primary"
                            middle
                            class="ma-2" @click="warningReportDownload()">
                          下载实时预警数据报表
                        </v-btn>
                        <v-btn
                            color="primary"
                            middle
                            class="ma-2" @click="showOffLineConfigDialog()">
                          离线预警配置
                        </v-btn>

                        <v-btn
                            color="primary"
                            middle
                            class="ma-2" @click="lastSensorDataDownload()" :disabled="!query.isBinding || lastSensorDownloading">
                          下载最近一次节点上报信息
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>

        </v-container>

        <v-container fluid class="pt-0 pl-12 pr-12">
            <v-row align="start" no-gutter justify="center">
                <v-col
                        sm="12"
                        md="2"
                        class="pt-0"
                        cols="12">
                    <v-row>
                        <v-col
                                md="12"
                                sm="6"
                                cols="6">
                            <v-row align="center"
                                   class="numCardItem"
                                   :style="{backgroundImage:'url('+'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/card4.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405415&Signature=ms7%2FQZk0IjLbYkf2PxHVEctqod4%3D'+')'}">
                                <v-col
                                        cols="4">
                                    <img style="width:2rem;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/zongshu%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405441&Signature=Mb2kULQnRR2Sfqx3NMJ1aHvhX7c%3D"
                                         alt="">
                                </v-col>
                                <v-col
                                        cols="4">
                                    总数
                                </v-col>
                                <v-col
                                        class="text-left"
                                        cols="4">
                                    {{collectorStatusCount.allCount}}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                                sm="6"
                                md="12"
                                cols="6">
                            <v-row align="center"
                                   class="numCardItem"
                                   :style="{backgroundImage:'url('+'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/card3.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405512&Signature=suwfgNUyYAPw5gcsvJYjKmIMiCw%3D'+')'}">
                                <v-col
                                        cols="4">
                                    <img style="width:2rem;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/zhengchang%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405548&Signature=%2Fq2CPNlBprHayKoBOa3AgiRlEgY%3D"
                                         alt="">
                                </v-col>
                                <v-col
                                        cols="4">
                                    正常
                                </v-col>
                                <v-col
                                        class="text-left"
                                        cols="4">
                                    {{collectorStatusCount.normalCount}}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                                sm="6"
                                md="12"
                                cols="6">
                            <v-row align="center"
                                   class="numCardItem"
                                   :style="{backgroundImage:'url('+'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/card2.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405569&Signature=j%2FIvcgol8gvzf2ZpuEJZ1MeqrpQ%3D'+')'}">
                                <v-col
                                        cols="4">
                                    <img style="width:2rem;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/yujing%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405591&Signature=RXQfeTFKzt%2FojrUriJTLULFzzn4%3D"
                                         alt="">
                                </v-col>
                                <v-col
                                        cols="4">
                                    预警
                                </v-col>
                                <v-col
                                        class="text-left"
                                        cols="4">
                                    {{collectorStatusCount.warningCount}}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                                sm="6"
                                md="12"
                                cols="6">
                            <v-row align="center"
                                   class="numCardItem"
                                   :style="{backgroundImage:'url('+'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/lixian1%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406832&Signature=C32uv12YpB%2BjV2djf2bjQhTa4lc%3D'+')'}">
                                <v-col
                                        cols="4">
                                    <img style="width:2rem;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/lixian2%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406852&Signature=KzEVp%2B69eXLMBPR21aq6hfkVG5g%3D"
                                         alt="">
                                </v-col>
                                <v-col
                                        cols="4">
                                    离线
                                </v-col>
                                <v-col
                                        class="text-left"
                                        cols="4">
                                    {{collectorStatusCount.offlineCount}}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                                sm="6"
                                md="12"
                                cols="6">
                            <v-row align="center"
                                   class="numCardItem"
                                   :style="{backgroundImage:'url('+'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/card1.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406872&Signature=5KWLoTvIsRhcbMps5kCWu5y%2B160%3D'+')'}">
                                <v-col
                                        cols="4">
                                    <img style="width:2rem;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/lixian%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406895&Signature=9zHmfYMgQRNnyelMfolMNKYjuQ8%3D"
                                         alt="">
                                </v-col>
                                <v-col
                                        cols="4">
                                    待安装
                                </v-col>
                                <v-col
                                        class="text-left"
                                        cols="4">
                                    {{collectorStatusCount.notBindCount}}
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col
                        align-self="start"
                        class="pt-0"
                        sm="12"
                        md="10"
                        cols="12"
                        id="listView">
                    <div
                            fluid
                            class="pt-0 cardListView"
                            v-show="list.length>0"
                            v-infinite-scroll="loadMore"
                            infinite-scroll-disabled="busy"
                            infinite-scroll-distance="5"
                            :style="{height:listViewHeight+'px'}">
                        <v-row>
                            <template
                                    v-for="(item,index) in list">
                                <v-hover v-slot:default="{ hover }">
                                    <v-col
                                            class="pt-0"
                                            md="4"
                                            sm="6"
                                            cols="12">
                                        <v-card
                                                style="height:100%;"
                                                :elevation="hover ? 12 : 2"
                                                :class="{ 'on-hover': hover }"
                                        >
                                            <div class="cardItem">

                                                <div @click="jumpGo(item)" style="cursor:pointer;">
                                                    <!--01正常 02离线-->

                                                    <!--正常-->
                                                    <v-row v-if="item.collectorState=='01'&&!item.isWarning"
                                                           align="center"
                                                           class="cardTitle cardTitle-normal no-gutters">
                                                        <div>
                                                            NO.{{index+1}}
                                                        </div>
                                                        <div v-if="!!item.hospName">
                                                            <img style="width:1rem;height:0.8rem;margin-right:0.2rem"
                                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/yy.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406918&Signature=%2BDRGEEwke2RNLCueke0C68RFGEM%3D"
                                                                 alt="">
                                                            <span v-if="item.hospName.length<12"
                                                                  style="max-width:10rem;height:1.2rem;"
                                                                  class="d-inline-block text-truncate">{{item.hospName}}</span>
                                                            <v-tooltip v-if="item.hospName.length>=12" top>
                                                                <template v-slot:activator="{ on }">
                                                                <span style="max-width:10rem;height:1.2rem;" v-on="on"
                                                                      class="d-inline-block text-truncate">{{item.hospName}}</span>
                                                                </template>
                                                                <span>{{item.hospName}}</span>
                                                            </v-tooltip>

                                                        </div>
                                                        <div v-if="!!item.deptName">
                                                            <img style="width:1rem;height:0.8rem;margin-right:0.2rem;"
                                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/keshi%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406936&Signature=ba6st7PKXIXOhnDZBRPg%2BAbEktw%3D"
                                                                 alt="">
                                                            <span v-if="item.deptName.length<5">{{item.deptName}}</span>
                                                            <v-tooltip v-if="item.deptName.length>=5" top>
                                                                <template v-slot:activator="{ on }">
                                                                <span style="max-width:6rem;height:1.2rem;" v-on="on"
                                                                      class="d-inline-block text-truncate">{{item.deptName}}</span>
                                                                </template>
                                                                <span>{{item.deptName}}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </v-row>
                                                    <!--预警中-->
                                                    <v-row v-if="item.collectorState=='01'&&item.isWarning"
                                                           align="center"
                                                           class="cardTitle cardTitle-warning no-gutters">
                                                        <div>
                                                            NO.{{index+1}}
                                                        </div>
                                                        <div v-if="!!item.hospName">
                                                            <img style="width:1rem;height:0.8rem;margin-right:0.2rem"
                                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/yy.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406918&Signature=%2BDRGEEwke2RNLCueke0C68RFGEM%3D"
                                                                 alt="">
                                                            <span v-if="item.hospName.length<12"
                                                                  style="max-width:10rem;height:1.2rem;"
                                                                  class="d-inline-block text-truncate">{{item.hospName}}</span>
                                                            <v-tooltip v-if="item.hospName.length>=12" top>
                                                                <template v-slot:activator="{ on }">
                                                                <span style="max-width:10rem;height:1.2rem;" v-on="on"
                                                                      class="d-inline-block text-truncate">{{item.hospName}}</span>
                                                                </template>
                                                                <span>{{item.hospName}}</span>
                                                            </v-tooltip>

                                                        </div>
                                                        <div v-if="!!item.deptName">
                                                            <img style="width:1rem;height:0.8rem;margin-right:0.2rem;"
                                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/keshi%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406936&Signature=ba6st7PKXIXOhnDZBRPg%2BAbEktw%3D"
                                                                 alt="">
                                                            <span v-if="item.deptName.length<5">{{item.deptName}}</span>
                                                            <v-tooltip v-if="item.deptName.length>=5" top>
                                                                <template v-slot:activator="{ on }">
                                                                <span style="max-width:6rem;height:1.2rem;" v-on="on"
                                                                      class="d-inline-block text-truncate">{{item.deptName}}</span>
                                                                </template>
                                                                <span>{{item.deptName}}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </v-row>
                                                    <!--离线-->
                                                    <v-row v-if="item.collectorState=='02'" align="center"
                                                           class="cardTitle cardTitle-off no-gutters">
                                                        <div>
                                                            NO.{{index+1}}
                                                        </div>
                                                        <div v-if="!!item.hospName">
                                                            <img style="width:1rem;height:0.8rem;margin-right:0.2rem"
                                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/yy.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406918&Signature=%2BDRGEEwke2RNLCueke0C68RFGEM%3D"
                                                                 alt="">
                                                            <span v-if="item.hospName.length<12"
                                                                  style="max-width:10rem;height:1.2rem;"
                                                                  class="d-inline-block text-truncate">{{item.hospName}}</span>
                                                            <v-tooltip v-if="item.hospName.length>=12" top>
                                                                <template v-slot:activator="{ on }">
                                                                <span style="max-width:10rem;height:1.2rem;" v-on="on"
                                                                      class="d-inline-block text-truncate">{{item.hospName}}</span>
                                                                </template>
                                                                <span>{{item.hospName}}</span>
                                                            </v-tooltip>

                                                        </div>
                                                        <div v-if="!!item.deptName">
                                                            <img style="width:1rem;height:0.8rem;margin-right:0.2rem;"
                                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/keshi%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406936&Signature=ba6st7PKXIXOhnDZBRPg%2BAbEktw%3D"
                                                                 alt="">
                                                            <span v-if="item.deptName.length<5">{{item.deptName}}</span>
                                                            <v-tooltip v-if="item.deptName.length>=5" top>
                                                                <template v-slot:activator="{ on }">
                                                                <span style="max-width:6rem;height:1.2rem;" v-on="on"
                                                                      class="d-inline-block text-truncate">{{item.deptName}}</span>
                                                                </template>
                                                                <span>{{item.deptName}}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </v-row>
                                                    <!--未安装-->
                                                    <v-row v-if="!item.isBinding" align="center"
                                                           class="cardTitle cardTitle-uninstall no-gutters">
                                                        <div>
                                                            NO.{{index+1}}
                                                        </div>
                                                        <div v-if="!!item.hospName">
                                                            <img style="width:1rem;height:0.8rem;margin-right:0.2rem"
                                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/yy.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406918&Signature=%2BDRGEEwke2RNLCueke0C68RFGEM%3D"
                                                                 alt="">
                                                            <span v-if="item.hospName.length<12"
                                                                  style="max-width:10rem;height:1.2rem;"
                                                                  class="d-inline-block text-truncate">{{item.hospName}}</span>
                                                            <v-tooltip v-if="item.hospName.length>=12" top>
                                                                <template v-slot:activator="{ on }">
                                                                <span style="max-width:10rem;height:1.2rem;" v-on="on"
                                                                      class="d-inline-block text-truncate">{{item.hospName}}</span>
                                                                </template>
                                                                <span>{{item.hospName}}</span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div v-if="!!item.deptName">
                                                            <img style="width:1rem;height:0.8rem;margin-right:0.2rem;"
                                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/keshi%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406936&Signature=ba6st7PKXIXOhnDZBRPg%2BAbEktw%3D"
                                                                 alt="">
                                                            <span v-if="item.deptName.length<5">{{item.deptName}}</span>
                                                            <v-tooltip v-if="item.deptName.length>=5" top>
                                                                <template v-slot:activator="{ on }">
                                                                <span style="max-width:6rem;height:1.2rem;" v-on="on"
                                                                      class="d-inline-block text-truncate">{{item.deptName}}</span>
                                                                </template>
                                                                <span>{{item.deptName}}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </v-row>

                                                    <v-container class="pb-0" fluid>
                                                        <v-row>
                                                            <v-col cols="12">
                                                            <span v-if="!item.businessName" class="textIcon"
                                                                  style="background:transparent;color:transparent;">11</span>
                                                                <span v-else
                                                                      class="textIcon">{{item.businessName}}</span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="6" class="pt-0 pb-0">
                                                                <div class="cardItemTitle">采集器名称</div>
                                                                <div class="d-inline-block">
                                                                    {{item.collectorName}}
                                                                </div>
                                                                <!--<div v-if="item.collectorName.length<10"-->
                                                                <!--style="max-width:100%"-->
                                                                <!--class="d-inline-block text-truncate">-->
                                                                <!--{{item.collectorName}}-->
                                                                <!--</div>-->
                                                                <!--<v-tooltip v-else top>-->
                                                                <!--<template v-slot:activator="{ on }">-->
                                                                <!--<div style="max-width:100%" v-on="on"-->
                                                                <!--class="d-inline-block text-truncate">-->
                                                                <!--{{item.collectorName}}-->
                                                                <!--</div>-->
                                                                <!--</template>-->
                                                                <!--<span>{{item.collectorName}}</span>-->
                                                                <!--</v-tooltip>-->

                                                            </v-col>
                                                            <v-col cols="6" class="pt-0 pb-0">
                                                                <div class="cardItemTitle">MAC</div>
                                                                <div style="font-size:0.9rem;">{{item.collectorMac}}
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="6">
                                                                <div class="cardItemTitle">规格</div>
                                                                <div>已配置
                                                                    <span>{{item.configSensorCount}}</span>/{{item.maxSensorCount}}节点
                                                                </div>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <div class="cardItemTitle">型号</div>
                                                                <div>{{item.collectorModel}}</div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </div>

                                                <v-container fluid>
                                                    <v-row no-gutters
                                                           justify="space-between"
                                                           v-if="item.isBinding">
                                                        <v-col cols="12"
                                                               style="display:flex;align-items: center;justify-content: space-between">
                                                            <span text
                                                                  class="detailBtnStyle"
                                                                  @click.stop="showDetailDialog(item)">详情</span>
                                                            <span @click.stop="toggleCover(item,index)"
                                                                  :class="item.isActive?'talkIcon talkIconActive':'talkIcon'"
                                                            ></span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row no-gutters
                                                           v-else>
                                                        <v-col cols="12"
                                                               style="display:flex;align-items: center;justify-content: space-between">
                                                           <span text
                                                                 class="detailBtnStyle"
                                                                 @click.stop="showDetailDialog(item)">详情</span>
                                                           <span @click.stop="toggleCover(item,index)"
                                                                 :class="item.isActive?'talkIcon talkIconActive':'talkIcon'"
                                                           ></span>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>

                                                <div class="handle" v-show="item.isActive">
                                                    <v-row justify="center" class="pt-6">
                                                        <v-col cols="3"
                                                               v-if="item.isBinding==true"
                                                               @click.stop="showNodeConfigDialog(item,index)"
                                                               class="text-center">
                                                            <v-img
                                                                    class="mb-4"
                                                                    height="3rem"
                                                                    contain
                                                                    src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/pzcgq%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753407064&Signature=quEeeomhOLTZIn49Ln0ovBkqEDU%3D"
                                                            />
                                                            <div>配置传感器</div>
                                                            <div>采集节点</div>
                                                        </v-col>
                                                        <!--01正常 02离线-->
<!--                                                        <v-col cols="3"-->
<!--                                                               v-if="item.collectorState=='02' && item.isBinding==true"-->
<!--                                                               @click.stop="toggleIot(item,index)"-->
<!--                                                               class="text-center">-->
<!--                                                            <v-img-->
<!--                                                                    class="mb-4"-->
<!--                                                                    height="3rem"-->
<!--                                                                    contain-->
<!--                                                                    src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/cjqsx%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753407092&Signature=zKttSSWVwlOCfsjMn6KAwsVqE%2BE%3D"-->
<!--                                                            />-->
<!--                                                            <span>采集器上线</span>-->
<!--                                                        </v-col>-->
<!--                                                        <v-col cols="3"-->
<!--                                                               v-if="item.collectorState=='01' && item.isBinding==true"-->
<!--                                                               @click.stop="toggleIot(item,index)"-->
<!--                                                               class="text-center">-->
<!--                                                            <v-img-->
<!--                                                                    class="mb-4"-->
<!--                                                                    height="3rem"-->
<!--                                                                    contain-->
<!--                                                                    src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/cjqxx%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753407121&Signature=g4o%2FkmIRKCVOck4sZ3uQE705o78%3D"-->
<!--                                                            />-->
<!--                                                            <span>采集器下线</span>-->
<!--                                                        </v-col>-->
                                                        <v-col cols="3"
                                                               v-if="item.isBinding==true"
                                                               @click.stop="unbindCollector(item,index)"
                                                               class="text-center">
                                                            <v-img
                                                                    class="mb-4"
                                                                    height="3rem"
                                                                    contain
                                                                    src="http://zzitec-public.oss-cn-shanghai.aliyuncs.com/daq-web/unbindcollector.png"
                                                            />
                                                            <span>采集器解绑</span>
                                                        </v-col>
                                                        <v-col cols="3"
                                                               @click.stop="delCollector(item,index)"
                                                               class="text-center">
                                                            <v-img
                                                                    class="mb-4"
                                                                    height="3rem"
                                                                    contain
                                                                    src="http://zzitec-public.oss-cn-shanghai.aliyuncs.com/daq-web/deleteconllector.png"
                                                            />
                                                            <span>采集器删除</span>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </div>

                                        </v-card>
                                    </v-col>

                                </v-hover>

                            </template>

                        </v-row>
                        <div v-if="!hasMore" class="text-center">没有更多数据啦~</div>
                    </div>
                    <div
                            v-show="list.length<1">
                        <v-img
                                class="mb-4 mt-12"
                                height="15rem"
                                contain
                                src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/kong%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753407151&Signature=%2B57LKy2vLkoIlF3nAkWZ4U%2B034s%3D"></v-img>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <!--详情弹框 start-->
        <v-dialog
                v-model="detailDialog"
                max-width="600"
        >
            <v-container fluid style="background-color:#fff;">
                <v-row class="pb-0">
                    <v-col class="font-weight-bold">
                        采集器基本信息:
                    </v-col>
                </v-row>
                <v-row class="pb-0">
                    <v-col :cols="3">
                        采集器ID：
                    </v-col>
                    <v-col :cols="3">
                        {{detailData.id}}
                    </v-col>
                    <!--<v-col :cols="3">-->
                    <!--采集器供应商：-->
                    <!--</v-col>-->
                    <!--<v-col :cols="3">-->
                    <!--{{detailData.supplierId}}-->
                    <!--</v-col>-->
                </v-row>
                <v-row class="pb-0">
                    <v-col :cols="3">
                        名称：
                    </v-col>
                    <v-col :cols="3">
                        {{detailData.collectorName}}
                    </v-col>
                    <v-col :cols="3">
                        型号：
                    </v-col>
                    <v-col :cols="3">
                        {{detailData.collectorModel}}
                    </v-col>
                </v-row>
                <v-row class="pb-0">
                    <v-col :cols="3">
                        出厂序列号：
                    </v-col>
                    <v-col :cols="3" style="word-break: break-all">
                        {{detailData.factSerialNo}}
                    </v-col>
                    <v-col :cols="3">
                        规格：
                    </v-col>
                    <v-col :cols="3">
                        {{detailData.maxSensorCount}}节点
                    </v-col>
                </v-row>
                <v-row class="pb-0">
                    <v-col :cols="3">
                        安装时间：
                    </v-col>
                    <v-col :cols="9">
                        {{!detailData.createDateTime?'无':detailData.createDateTime}}
                    </v-col>
                </v-row>
                <v-row class="pb-0">
                    <v-col :cols="3">
                        安装人：
                    </v-col>
                    <v-col :cols="9">
                        {{!detailData.acctName?'无':detailData.acctName}}
                    </v-col>
                </v-row>
                <v-row class="pb-0">
                    <v-col class="font-weight-bold">
                        监控对象:
                    </v-col>
                </v-row>
                <v-row class="pb-0">
                    <v-col :cols="3">
                        监控对象:
                    </v-col>
                    <v-col :cols="9">
                        {{!detailData.businessName?'无':detailData.businessName}}
                    </v-col>
                </v-row>
                <v-row class="pb-0">
                    <v-col :cols="3">
                        出厂序列号:
                    </v-col>
                    <v-col :cols="9">
                        {{!detailData.eqpFactSerialNo?'无':detailData.eqpFactSerialNo}}
                    </v-col>
                </v-row>
                <v-row class="pb-0">
                    <v-col :cols="3">
                        设备编号:
                    </v-col>
                    <v-col :cols="9">
                        {{!detailData.hospEqpId?'无':detailData.hospEqpId}}
                    </v-col>
                </v-row>
                <v-row class="pb-0">
                    <v-col :cols="3">
                        设备类型:
                    </v-col>
                    <v-col :cols="9">
                        {{!detailData.eqpType?'无':detailData.eqpType}}
                    </v-col>
                </v-row>
            </v-container>
        </v-dialog>
        <!--详情弹框 end-->

      <v-dialog
          v-model="offLineConfigDialog"
          max-width="20%">
        <div class="nodeItemStyle">

          <v-form
              ref="offLineConfig"
              v-model="offLineConfig.valid"
          >
            <v-container fluid>
              <v-card-title class="font-weight-bold">
                采集器离线预警配置
              </v-card-title>
              <v-switch v-model="offLineConfig.offLineWarnFlag"
                        class="ma-2"
                        label="离线预警开关">
              </v-switch>
              <v-text-field
                  class="sm1"
                  v-model="offLineConfig.warnDuration"
                  :counter="2"
                  :rules="numberRules"
                  label="采集器无数据预警小时数"
                  required
              ></v-text-field>
              <v-text-field
                  class="sm1"
                  v-model="offLineConfig.offLineDuration"
                  :counter="2"
                  :rules="numberRules"
                  label="采集器无数据转为离线小时数"
                  required
              ></v-text-field>
              <span v-if="!offLineConfig.notifier||offLineConfig.notifier.length==0">增加消息通知人：</span>
              <span v-if="offLineConfig.notifier && offLineConfig.notifier.length!=0">消息通知人：</span>
              <v-row v-for="(item,index) in offLineConfig.notifier"
                     align="center"
                     :key="index">
                <v-col :cols="1">
                  {{index+1}}.
                </v-col>
                <v-col :cols="8">
                  <v-text-field
                      class="text-body-2"
                      v-model="item.acctPhone"
                      counter="11"
                      :rules="phoneRules"
                      label="请输入手机号"
                      clearable
                      @click:append="queryOffLinePerson(item,index)"
                      @change="queryOffLinePerson(item,index)"
                      append-icon="search"
                      required
                  ></v-text-field>
                  <v-text-field
                      class="pt-xs-1"
                      v-model="item.acctName"
                      v-show="true"
                      disabled
                      :rules="[v => !!v || '姓名必存在']"
                      label="手机号所属人(输入手机号后自动返显)"
                      required
                  ></v-text-field>
                </v-col>
                <v-col :cols="3" class="flex-view-style">
                  <v-btn icon color="primary"
                         @click="removeOffLineContactPerson(index)">
                    <v-icon dark>remove_circle</v-icon>
                  </v-btn>
                  <v-btn icon color="primary"
                         v-if="index==offLineConfig.notifier.length-1"
                         @click="addOffLineContactPerson">
                    <v-icon dark>add_circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-btn icon color="primary"
                     v-if="!offLineConfig.notifier||offLineConfig.notifier.length==0"
                     @click="addOffLineContactPerson">
                <v-icon dark>add_circle</v-icon>
              </v-btn>
              <div>
                <v-btn size="small" @click="offLineConfigSubmit" color="primary">确认</v-btn>
              </div>
            </v-container>
          </v-form>
        </div>
      </v-dialog>

        <!--采集器节点配置弹框 start-->
        <v-dialog
                v-model="nodeConfigDialog"
                max-width="90%">
            <div class="nodeItemStyle">
                <v-container fluid>
                    <v-card-title class="font-weight-bold">
                        配置传感器采集节点
                    </v-card-title>

                    <v-simple-table style="border:1px solid #999;">
                        <template>
                            <thead style="background-color:#999;color:#fff;">
                            <tr>
                                <th class="text-left">采集器编号</th>
                                <th class="text-left">采集器MAC</th>
                                <th class="text-left">采集器名称</th>
                                <th class="text-left">型号</th>
                                <th class="text-left">最大节点数</th>
                                <th class="text-left">安装对象</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in desserts" :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>{{ item.collectorMac }}</td>
                                <td>{{ item.collectorName }}</td>
                                <td>{{ item.collectorModel }}</td>
                                <td>{{ item.maxSensorCount }}</td>
                                <td>{{ item.businessName }}</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <v-container fluid style="height:30rem;overflow-y: auto">
                        <v-row>
                            <v-col v-for="(item,index) in nodeList"
                                   :key="index"
                                   md="2"
                                   sm="6"
                                   cols="12"
                                   class="text-center">
                                <div style="padding:0.5rem;border:1px solid #ddd;
                                border-radius: 0.5rem;position:relative;"
                                     :style="{backgroundColor:item.isConfigured?'#DCEBFF':''}">
                                    <div class="text-center">
                                        <span>{{item.sensorSeq}}#节点</span>
                                    </div>
                                    <v-form
                                            :ref="'form'+item.sensorId"
                                            v-model="item.valid"
                                    >
                                        <v-text-field
                                                v-model="item.collectPlace"
                                                :counter="10"
                                                :rules="positionRules"
                                                label="采集位置"
                                                required
                                                @change="configUpdate(item)"
                                        ></v-text-field>

                                        <Z-Source-Selector label="数据类型"
                                                           @changevalue="configUpdate(item)"
                                                           :rules="[v => !!v || '类型必选']"
                                                           :source="'DicSelector'"
                                                           :param="'COLLECT_DATA_TYPE'"
                                                           v-model="item.collectDataType">
                                        </Z-Source-Selector>


                                        <v-switch v-model="item.earlyWarning"
                                                  @change="configUpdate(item)"
                                                  class="ma-2"
                                                  label="预警开关"></v-switch>
                                    </v-form>

                                    <v-btn icon large color="primary"
                                           style="position:absolute;bottom:0;right:0;"
                                           @click="setUpWaringRules(item,index)">
                                        <v-icon>settings</v-icon>
                                    </v-btn>

                                </div>

                            </v-col>
                        </v-row>
                    </v-container>
                </v-container>

                <!--预警参数配置 start-->
                <v-expand-x-transition>
                    <div v-if="isShowWarningRules" style="width:30rem;padding:1rem;">
                        <div class="font-weight-bold text-center mb-4">
                            {{currentNode+1}}#节点预警参数配置
                            <v-btn icon color="primary" style="float: right;margin-right:2rem;"
                                   @click="isShowWarningRules=false">
                                <v-icon dark>close</v-icon>
                            </v-btn>
                        </div>
                        <div class="font-weight-bold mb-6">预警规则配置:</div>
                        <v-form
                                ref="warningRulesForm"
                                v-model="warningRulesForm.valid"
                        >

                            <Z-Source-Selector
                                    label="采集数据类型"
                                    @changevalue="getSelectorData(warningRulesForm.warnDataType)"
                                    :rules="[v => !!v || '类型必选']"
                                    source="WarnDataTypeSelector"
                                    :param="WarnDataTypeParam"
                                    v-model="warningRulesForm.warnDataType">
                            </Z-Source-Selector>

                            <!--数值类型 start-->
                            <template v-if="warningRulesForm.warnDataType=='01'">
                                <v-radio-group class="mt-0"
                                               row
                                               v-model="warningRulesForm.warnRule"
                                               label="预警规则:"
                                               :rules="[v => !!v || '必选']"
                                               required
                                               :mandatory="false">

                                    <v-radio v-for="(item,index) in radioList"
                                             :key="index"
                                             :label="item.label"
                                             :value="item.value"></v-radio>

                                </v-radio-group>
                                <template v-if="warningRulesForm.warnRule!='05'">
                                    <v-text-field
                                            class="pt-0"
                                            v-model="warningRulesForm.warnValue"
                                            :rules="numberRules"
                                            label="预警阀值"
                                            required
                                    ></v-text-field>
                                </template>
                                <template v-if="warningRulesForm.warnRule=='05'">
                                    <v-text-field
                                            class="pt-0"
                                            v-model="warningRulesForm.warnValue"
                                            :rules="numberRules"
                                            label="预警阀值下限"
                                            required
                                    ></v-text-field>
                                    <v-text-field
                                            class="pt-0"
                                            v-model="warningRulesForm.warnValueMax"
                                            :rules="numberRules"
                                            label="预警阀值上限"
                                            required
                                    ></v-text-field>
                                </template>
                            </template>

                            <!--范围start-->
                            <!--范围end-->
                            <!--数值类型 end-->

                            <!--是否类型 start-->
                            <template v-if="warningRulesForm.warnDataType=='02'">
                                <v-radio-group class="mt-0"
                                               row
                                               v-model="warningRulesForm.warnRule"
                                               label="预警规则:"
                                               :rules="[v => !!v || '必选']"
                                               required
                                               :mandatory="false">

                                    <v-radio v-for="(item,index) in radioList"
                                             :key="index"
                                             :label="item.label"
                                             :value="item.value"></v-radio>
                                </v-radio-group>

                                <v-radio-group class="mt-0"
                                               row
                                               v-model="warningRulesForm.warnValue"
                                               label="预警阀值:"
                                               :rules="[v => v==0||!!v || '必选']"
                                               required
                                               :mandatory="false">
                                    <v-radio label="是"
                                             :value="'1.0'"></v-radio>
                                    <v-radio label="否"
                                             :value="'0.0'"></v-radio>
                                </v-radio-group>
                            </template>
                            <!--是否类型 end-->

                            <div class="mb-6 font-weight-bold">报警策略配置:</div>
                            <div>
                                <Z-Source-Selector
                                        label="消息推送渠道:"
                                        required
                                        :rules="[v => !!v || '类型必选']"
                                        source="DicSelector"
                                        param="NOTIFY_TYPE"
                                        v-model="warningRulesForm.notifyType">
                                </Z-Source-Selector>
                            </div>
                            <v-row v-for="(item,index) in warningRulesForm.notifier"
                                   align="center"
                                   :key="index">
                                <v-col :cols="1">
                                    {{index+1}}.
                                </v-col>
                                <v-col :cols="8">
                                    <v-text-field
                                            class="pt-0"
                                            v-model="item.acctPhone"
                                            counter="11"
                                            :rules="phoneRules"
                                            label="请输入手机号"
                                            clearable
                                            @click:append="queryPerson(item,index)"
                                            @change="queryPerson(item,index)"
                                            append-icon="search"
                                            required
                                    ></v-text-field>
                                    <v-text-field
                                            class="pt-2"
                                            v-model="item.acctName"
                                            v-show="true"
                                            disabled
                                            :rules="[v => !!v || '姓名必存在']"
                                            label="手机号所属人(输入手机号后自动返显)"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col :cols="3" class="flex-view-style">
                                    <v-btn icon color="primary"
                                           @click="removeContactPerson(index)">
                                        <v-icon dark>remove_circle</v-icon>
                                    </v-btn>
                                    <v-btn icon color="primary"
                                           v-if="index==warningRulesForm.notifier.length-1"
                                           @click="addContactPerson">
                                        <v-icon dark>add_circle</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>


                            <span v-if="!warningRulesForm.notifier||warningRulesForm.notifier.length==0">增加消息通知人：</span>
                            <v-btn icon color="primary"
                                   v-if="!warningRulesForm.notifier||warningRulesForm.notifier.length==0"
                                   @click="addContactPerson">
                                <v-icon dark>add_circle</v-icon>
                            </v-btn>

                        </v-form>
                        <v-btn size="small" @click="confirmWarningRules" color="primary">确认</v-btn>
                    </div>
                </v-expand-x-transition>
                <!--预警参数配置 end-->

            </div>
        </v-dialog>
        <!--采集器节点配置弹框 end-->

        <!--设备文件导入弹框 start-->
        <v-dialog
                v-model="uploadDialog"
                max-width="60%">
            <div style="background-color:#fff;" class="pb-12">
                <v-card-title class="font-weight-bold">
                    上传文件
                </v-card-title>
                <v-row no-gutters justify="center">
                    <v-col
                            cols="6">
                        <v-form
                                ref="uploadFileForm"
                                v-model="uploadFormValid"
                        >
                            <v-file-input
                                    v-model="fileInfo"
                                    required
                                    :rules="[v => !!v || '文件必选']"
                                    show-size accept=".xls,.xlsx"
                                    @change="uploadFile"
                                    :disabled="loading.uploadIsLoading"
                                    :loading="loading.uploadIsLoading"
                                    label="点击选择文件，文件格后缀为：.xls、.xlsx"></v-file-input>
                        </v-form>

                    </v-col>
                </v-row>

                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">导入数据总数:100</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">处理失败数量:10</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">成功数量:20</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">更新已存在设备信息数量:30</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">新增设备录入数量:40</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">处理耗时:0</v-col>-->
                <!--</v-row>-->

            </div>
        </v-dialog>
        <!--设备文件导入弹框 end-->

        <z-notify ref="notify"></z-notify>

        <z-loading v-model="loading.isLoading"></z-loading>

        <z-confirm v-model="confirmDialog" @confirm="confirmToggleIot" :msg="msg"></z-confirm>

        <z-confirm v-model="unbindDialog" @confirm="unbind" :msg="msg"></z-confirm>

        <z-confirm v-model="deleteDialog" @confirm="del" :msg="msg"></z-confirm>

    </div>
</template>

<script>
  import ZSourceSelector from "@/components/ZSourceSelector"
  import ZLoading from "@/components/ZLoading"
  import ZConfirm from "@/components/ZConfirm"
  import infiniteScroll from 'vue-infinite-scroll'
  import {
    collectorManagePageQuery,
    statusInfoQuery,
    stateUpdate,
    collectorSensorQuery,
    configUpdate,
    warningConfigQuery,
    notifierQuery,
    warningConfigUpdate,
    collectorDetailQuery,
    collectorImport,
    deleteCollector,
    currentWarningReportDownload,
    lastDataDownload,
    unbind,
    offLineConfigUpdate,
    offLineConfigQuery
  } from '@/api/collectorManagement'
  import {getSelecotrData} from '@/api/selector'
  import {} from "@/api/collectorManagement";

  export default {
    name: "CollectorManagement",
    data: () => ({
      fileInfo: null,
      query: {
        hospId: '',
        deptId: '',
        collectorState: '',
        isWarning: false,
        isBinding: true,
        queryCondition: '',
        pagedQueryInfo: {
          pageSize: 10,
          index: 0,
          sum: 0
        }
      },
      lastSensorDownloading: false,
      collectorStatusCount: {
        allCount: 0,
        normalCount: 0,
        notBindCount: 0,
        offlineCount: 0,
        warningCount: 0
      },
      list: [],
      listViewHeight: '',
      busy: false,
      hasMore: true,
      detailDialog: false,
      nodeConfigDialog: false,
      offLineConfigDialog: false,
      confirmDialog: false,
      unbindDialog: false,
      deleteDialog: false,
      collectorId: {
          id: ''
      },
      uploadDialog: false,
      isSureDialog: true,
      loading: {
        isLoading: false,
        queryRequest: false,
        uploadIsLoading: false
      },
      desserts: [],
      typeList: [
        {text: '温度', value: '00'},
        {text: '湿度', value: '01'},
      ],
      valueTypeList: [
        {text: '数值型', value: '01'},
        {text: '布尔型', value: '02'},
      ],
      positionRules: [
        v => !!v || '采集位置必输',
        v => (v && v.length <= 30) || '少于30个字符',
      ],
      phoneRules: [
        v => !!v || '手机号必输',
        v => /1\d{10}/.test(v) || '手机号格式不正确',
        v => !!v && v.length <= 11 || '最多11位数'
      ],
      numberRules: [
        v => !!v || '必输',
        v => /^[0-9]+(.[0-9]*)?$/.test(v) || '数字格式',
      ],
      warningRulesForm: {
        valid: true,
        sensorId: "",
        warnDataType: "",
        warnRule: "",
        warnValue: "",
        warnValueMax: "",
        notifyType: "",
        notifier: [
          // {
          //   acctPhone: "",
          //   openId: "",
          //   acctName: "",
          //   acctId: ''
          // }
        ]
      },
      nodeList: [],
      isShowWarningRules: false,
      // 数值类型单选框
      radioList: [],
      currentNode: '',
      offLineConfig: {
        valid: true,
        offLineWarnFlag: true,
        warnDuration: null,
        offLineDuration: null,
        notifier: []
      },
      detailData: {
        // "id": "采集器id",
        // "businessId": "业务id",
        // "businessName": "业务name",
        // "bindType": "绑定对象类型",
        // "collectorName": "采集器名称",
        // "collectorSeq": "采集器序号",
        // "collectorMac": "采集器MAC地址",
        // // 采集器状态 01正常 02离线
        // "collectorState": "01",
        // "maxSensorCount": 12,
        // "configSensorCount": 3,
        // "stateStartTime": "状态开始时间",
        // "isBinding": true,
        // "isWarning": true,
        // "collectorModel": "采集器型号",
        // "supplierId": "供应商id",
        // "productionDate": "采集器出厂日期",
        // "factSerialNo": "出厂序列号",
        // "companyId": "公司id",
        // "createDateTime": "创建时间",
        // "updateDateTime": "上次更新时间"
      },
      uploadFormValid: true,
      WarnDataTypeParam: '',
      msg: '',
      currentoggleIot: {
        info: null,
        index: ''
      },
      currentNodeConfig: {
        info: null,
        index: ''
      }
    }),
    components: {
      ZSourceSelector,
      ZLoading,
      ZConfirm
    },
    watch: {
      'warningRulesForm.valid': {
        handler: function (newValue, oldValue) {
          console.log(newValue, '预警参数配置变化');
        }
      },
      'offLineConfig.valid': {
        handler: function (newValue, oldValue) {
          console.log(newValue, '离线预警参数配置变化');
        }
      },
      'nodeConfigDialog': {
        handler: function (newValue, oldValue) {
          if (!newValue) {
            // 关闭弹框的时候更新外部已配置节点个数
            var n = 0;
            this.nodeList.forEach(option => {
              if (option.isConfigured) {
                n++;
              }
            });
            this.list[this.currentNodeConfig.index].configSensorCount = n;
            this.list[this.currentNodeConfig.index].isActive = false;
            this.isShowWarningRules = false;
            this.nodeList = [];
          }
        }
      }
    },
    methods: {
      jump(url) {
          window.open(url, '_blank');
      },
      jumpGo(obj) {
        // alert("跳转节点实时监控页面并带着绑定对象的信息过去，两种传参方式");
        // 已绑定的采集器才能跳转
        if (obj.isBinding) {
          // this.$router.push({path: '/eqp-monitor', query: {name: obj.businessName}});
        }
        // this.$router.push({name:'EqpMonitor',params:{name:obj.businessName}});
      },
      //预警报表导出
      warningReportDownload(){
        currentWarningReportDownload().then(res=>{
          this.downloadFile(res)
        })
      },
      lastSensorDataDownload(){
        var reqData = JSON.parse(JSON.stringify(this.query));
        if (!reqData.isWarning) {
          reqData.isWarning = '';
        }
        this.lastSensorDownloading = true;
        lastDataDownload(reqData).then(res=>{
          this.downloadFile(res);
          this.lastSensorDownloading = false;
        })
      },
      sleep(time){
        var timeStamp = new Date().getTime();
        var endTime = timeStamp + time;
        while(true){
          if (new Date().getTime() > endTime){
            return;
          }
        }
      },
      downloadFile(url){
        console.log(url,'---------url---')
        let link = document.createElement('a');
        link.style.display = 'none';
        link.download='';
        link.href = url;
        document.body.appendChild(link);
        link.click();
        //下载完成后
        document.body.removeChild(link);
      },
      // 批量导入
      handleBatchImport() {
        this.uploadDialog = true;
        this.$nextTick(res => {
          this.$refs.uploadFileForm.reset();
        });
      },
      // 上传文件方法
      uploadFile() {
        // console.log(this.fileInfo, '文件信息');
        if (this.$refs.uploadFileForm.validate()) {
          this.loading.uploadIsLoading = true;
          var formData = new window.FormData();
          formData.append('file', this.fileInfo);
          collectorImport(formData).then(res => {
            this.loading.uploadIsLoading = false;
            this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
            this.uploadDialog = false;
            this.search();
          }).catch(err => {
            this.loading.uploadIsLoading = false;
          });
        }
        // console.log(document.querySelector('input[type=file]').files[0],'131231312');
      },
      showOffLineConfigDialog() {
        offLineConfigQuery({}).then(res => {
          this.offLineConfig = res;
        }).catch(err => {
        });
        this.offLineConfigDialog = true;
      },
      showNodeConfigDialog(item, index) {
        this.currentNodeConfig.info = item;
        this.currentNodeConfig.index = index;
        this.loading.isLoading = true;
        var reqData = {
          collectorId: item.id
        };
        collectorSensorQuery(reqData).then(res => {
          res.forEach(option => {
            option.valid = false;
          })
          this.nodeList = res;
          this.nodeConfigDialog = true;
          this.loading.daqTypeEqpInfoLoading == false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;;
        }).catch(err => {
          this.loading.daqTypeEqpInfoLoading == false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;;
        })

        collectorDetailQuery(reqData).then(res => {
          this.desserts = [];
          this.desserts.push(res);
        }).catch(err => {

        });
      },
      // 切换采集器上下线
      toggleIot(item, index) {
        this.currentoggleIot.info = item;
        this.currentoggleIot.index = index;
        if (item.collectorState == '01') {
          this.msg = "采集器确认下线?"
        } else {
          this.msg = "采集器确认上线?"
        }
        this.confirmDialog = true;
      },

        // 解绑采集器
        unbindCollector(item, index) {
            this.currentoggleIot.info = item;
            this.currentoggleIot.index = index;
            this.collectorId.id = item.id;
            this.msg = "确认解绑采集器?";
            this.unbindDialog = true;
        },
        unbind() {
            unbind(this.collectorId).then(res => {
                this.$refs.notify.show("解绑成功", {
                    timeout: 1000,
                    color: 'success'
                });
                this.search();
                this.statusInfoQuery();
                this.unbindDialog = false;
                this.toggleCover(this.currentoggleIot.info, this.currentoggleIot.index);
            }).catch(err => {
                this.$refs.notify.show("解绑失败", {
                    timeout: 1000,
                    color: 'error'
                });
                this.search();
                this.statusInfoQuery();
                this.unbindDialog = false;
                this.toggleCover(this.currentoggleIot.info, this.currentoggleIot.index);
            });
        },


        // 解绑采集器
        delCollector(item, index) {
            this.currentoggleIot.info = item;
            this.currentoggleIot.index = index;
            this.collectorId.id = item.id;
            this.msg = "确认删除集器?";
            this.deleteDialog = true;
        },
        del() {
            deleteCollector(this.collectorId).then(res => {
                this.$refs.notify.show("删除成功", {
                    timeout: 1000,
                    color: 'success'
                });
                this.search();
                this.statusInfoQuery();
                this.deleteDialog = false;
                this.toggleCover(this.currentoggleIot.info, this.currentoggleIot.index);
            }).catch(err => {
                this.$refs.notify.show("删除失败", {
                    timeout: 1000,
                    color: 'error'
                });
                this.search();
                this.statusInfoQuery();
                this.deleteDialog = false;
                this.toggleCover(this.currentoggleIot.info, this.currentoggleIot.index);
            });
        },
      confirmToggleIot() {
        var reqData = {
          id: this.currentoggleIot.info.id,
          collectorState: this.currentoggleIot.info.collectorState == '01' ? '02' : '01'
        };
        stateUpdate(reqData).then(res => {
          this.list[this.currentoggleIot.index].collectorState = this.list[this.currentoggleIot.index].collectorState == '01' ? '02' : '01';
          this.$refs.notify.show(this.list[this.currentoggleIot.index].collectorState == '01' ? "采集器上线成功" : "采集器下线成功", {
            timeout: 1000,
            color: 'success'
          })
          // 更新左侧总览
          this.statusInfoQuery();
          this.confirmDialog = false;
          this.toggleCover(this.currentoggleIot.info, this.currentoggleIot.index);
        }).catch(err => {

        });
      },
      offLineConfigSubmit() {
        if (this.$refs.offLineConfig.validate()) {
          offLineConfigUpdate(this.offLineConfig).then(res => {
            this.$refs.notify.show("配置成功", {timeout: 1000, color: 'success'})
            this.offLineConfigDialog = false;
          }).catch(err => {

          });
        }
      },
      // 查找消息通知人
      queryOffLinePerson(item, index) {
        console.log(item, index, '消息推送人信息');
        if (!!item.acctPhone && /1\d{10}/.test(item.acctPhone) && item.acctPhone.length < 12) {
          console.log("ajax调用");
          notifierQuery({acctPhone: item.acctPhone}).then(res => {
            if (!!res.acctName) {
              this.offLineConfig.notifier[index].acctName = res.acctName;
              this.offLineConfig.notifier[index].openId = res.openId;
              this.offLineConfig.notifier[index].acctId = res.acctId;
            }
          }).catch(err => {

          });
        } else {
          this.offLineConfig.notifier[index].acctName = '';
        }
      },
      // 查找消息通知人
      queryPerson(item, index) {
        console.log(item, index, '消息推送人信息');
        if (!!item.acctPhone && /1\d{10}/.test(item.acctPhone) && item.acctPhone.length < 12) {
          console.log("ajax调用");
          notifierQuery({acctPhone: item.acctPhone}).then(res => {
            if (!!res.acctName) {
              this.warningRulesForm.notifier[index].acctName = res.acctName;
              this.warningRulesForm.notifier[index].openId = res.openId;
              this.warningRulesForm.notifier[index].acctId = res.acctId;
            }
          }).catch(err => {

          });
        } else {
          this.warningRulesForm.notifier[index].acctName = '';
        }
      },
      // 提交预警参数配置
      confirmWarningRules() {
        this.$refs.warningRulesForm.validate();
        if (this.$refs.warningRulesForm.validate()) {
          warningConfigUpdate(this.warningRulesForm).then(res => {
            this.$refs.notify.show("配置成功", {timeout: 1000, color: 'success'})
            this.isShowWarningRules = false;
          }).catch(err => {

          });
        }
      },

      // 增加联系人
      addOffLineContactPerson() {
        this.offLineConfig.notifier.push(
            {
              acctPhone: "",
              openId: "",
              acctName: "",
              acctId: ''
            }
        );
      },
      // 增加联系人
      addContactPerson() {
        this.warningRulesForm.notifier.push(
          {
            acctPhone: "",
            openId: "",
            acctName: "",
            acctId: ''
          }
        );
      },
      //删除离线联系人
      removeOffLineContactPerson(index) {
        this.offLineConfig.notifier.splice(index, 1);
      },
      //删除联系人
      removeContactPerson(index) {
        this.warningRulesForm.notifier.splice(index, 1);
      },
      // 设置按钮
      setUpWaringRules(item, index) {
        if (this.$refs['form' + item.sensorId][0].validate()) {
          this.loading.isLoading = true;
          console.log("当前节点的信息", item, index);
          warningConfigQuery({sensorId: item.sensorId}).then(res => {
            this.currentNode = index;
            this.WarnDataTypeParam = this.nodeList[index].collectDataType;
            this.isShowWarningRules = true;
            this.$nextTick(() => {
              this.$refs.warningRulesForm.reset();
              this.$nextTick(() => {
                res.valid = false;
                if (!res.notifier) {
                  res.notifier = [
                    // {
                    //   acctPhone: "",
                    //   openId: "",
                    //   acctName: "",
                    //   acctId: ''
                    // }
                  ];
                }
                this.warningRulesForm = res;
                if (!res.warnDataType) {

                } else {
                  this.getSelectorData(res.warnDataType);
                }
                this.loading.daqTypeEqpInfoLoading == false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;;
              });
            });
          }).catch(err => {
            this.loading.daqTypeEqpInfoLoading == false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;;
          });
        }
      },
      configUpdate(item) {
        if (this.$refs['form' + item.sensorId][0].validate()) {
          item.isConfigured = true;
          configUpdate(item).then(res => {
            this.$refs.notify.show("节点信息配置成功", {timeout: 1000, color: 'success'});
            this.isShowWarningRules = false;
          }).catch(err => {
            var reqData = {
              collectorId: item.collectorId
            };
            collectorSensorQuery(reqData).then(res => {
              res.forEach(option => {
                option.valid = false;
              })
              this.nodeList = res;
            }).catch(err => {

            })
          });
        }
      },
      search() {
        this.loading.queryRequest = true;
        this.query.pagedQueryInfo.index = 1;
        this.queryList();
      },
      queryList() {
        // 调ajax方法获取数据
        console.log(this.query, '请求参数');
        var reqData = JSON.parse(JSON.stringify(this.query));
        if (!reqData.isWarning) {
          reqData.isWarning = '';
        }
        collectorManagePageQuery(reqData).then(res => {
          this.loading.queryRequest = false;
          if (this.query.pagedQueryInfo.index == 1) {
            this.list = [];
          }
          res.list.forEach(option => {
            option.isActive = false;
          })
          this.list = this.list.concat(res.list);
          this.statusInfoQuery();
          this.query.pagedQueryInfo.sum = res.total;
          if (this.query.pagedQueryInfo.sum <= this.list.length) {
            this.busy = true;
            this.hasMore = false;
          } else {
            this.busy = false;
            this.hasMore = true;
          }
        }).catch(err => {
          this.loading.queryRequest = false;
        });
      },
      resetQuery() {
        this.$refs.queryForm.reset();
        this.search();
      },
      statusInfoQuery() {
        statusInfoQuery({}).then(res => {
          this.collectorStatusCount = res;
          console.log(this.collectorStatusCount, 'this.collectorStatusCount');
        }).catch(err => {

        });
      },
      toggleCover(item, index) {
        this.list[index].isActive = !this.list[index].isActive
      },
      initListViewHeight() {
        var element = document.getElementById('listView');
        var actualTop = element.offsetTop;
        var current = element.offsetParent;

        while (current !== null) {
          actualTop += current.offsetTop;
          current = current.offsetParent;
        }
        var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        console.log(actualTop, '距离顶部的像素');
        console.log(height, '屏幕高');
        this.listViewHeight = height - actualTop - 30;
        console.log(this.listViewHeight, '容器高');
      },
      loadMore() {
        this.busy = true;
        this.query.pagedQueryInfo.index++;
        // alert(this.query.pagedQueryInfo.index+'当前页码');
        this.queryList();
      },
      showDetailDialog(item) {
        this.loading.isLoading = true;
        collectorDetailQuery({collectorId: item.id}).then(res => {
          this.detailDialog = true;
          this.detailData = res;
          this.loading.daqTypeEqpInfoLoading == false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;;
        }).catch(err => {
          this.loading.daqTypeEqpInfoLoading == false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;;
        });

      },
      // 预警规则
      getSelectorData(warnDataType) {
        if (!warnDataType) {
          return;
        }
        getSelecotrData('WarnRuleSelector', warnDataType).then(res => {
          var obj = JSON.parse(JSON.stringify(this.warningRulesForm));
          if (warnDataType == '01') {
            // 数值型
            this.radioList = res;
          } else if (warnDataType == '02') {
            // 是否型
            this.radioList = res;
          }
          this.$nextTick(res => {
            this.warningRulesForm.warnRule = obj.warnRule
          });
        }).catch(err => {

        })
      }
    },
    mounted() {
      window.onresize = () => {
        return (() => {
          var elem = document.getElementById("listView");
          if (!elem) {

          } else {
            this.initListViewHeight();
          }
        })();
      };
      this.initListViewHeight();
    },
  }
</script>

<style scoped>

    .numCardItem {
        width: 100%;
        height: 4.1rem;
        /*height: 6rem;*/
        background-color: #1E58BF;
        text-align: center;
        /*line-height: 100px;*/
        color: #fff;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 0.3em;
    }

    .cardItem {
        background-color: #fff;
        border-radius: 0.5rem;
        position: relative;
    }

    .cardItemTitle {
        font-size: 0.875rem;
        color: #666;
    }

    .cardTitle {
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
        /*font-size:0.8rem;*/
        color: #fff;
        padding: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .cardTitle-warning {
        background-color: #FF6C00;
    }

    .cardTitle-normal {
        background-color: #1EBF76;
    }

    .cardTitle-off {
        background-color: #0095FF;
    }

    .cardTitle-uninstall {
        background-color: #585F64;
    }

    .cardTitle-waiting {
        background-color: #fff;
    }

    .textIcon {
        padding: 0.3rem 0.5rem;
        background-color: #F1F1F1;
        margin-right: 0.5rem;
    }

    .talkIcon {
        display: inline-block;
        width: 1.6rem;
        height: 1.5rem;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/peizhi2%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753407178&Signature=VdmQxiIhyhIqsarvqcZIWLEOWeQ%3D");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        cursor: pointer;
    }

    .talkIconActive {
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/peizhi%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753407199&Signature=XzMSYlLyQ%2F1CBAcWnKhWQAK8OmU%3D");
    }

    .handle {
        width: 100%;
        height: 80%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: rgba(0, 0, 0, 0.8);
        border-radius: 0.5rem;
        color: #fff;
        user-select: none;
    }

    .handle::after {
        content: '';
        display: block;
        position: absolute;
        width: 0rem;
        height: 0rem;
        bottom: -1.6rem;
        right: 1.5rem;
        border: 0.8rem solid transparent;
        border-top-color: rgba(0, 0, 0, 0.8);
    }

    .cardListView {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .cardListView::-webkit-scrollbar {
        width: 6px;
    }

    .cardListView::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }

    .cardListView::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }

    #listView {
        /*overflow-x: hidden;*/
        /*overflow-y: auto;*/
    }

    .nodeItemStyle {
        background-color: #fff;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }

    .detailBtnStyle {
        color: #666;
        cursor: pointer;
    }
</style>
